
/* src/Components/CookieBanner.js */
import React, { useEffect, useState } from 'react';
import { Button } from 'antd';
import './style.css';

const STORAGE_KEY = 'cookie_consent';

export default function CookieBanner({ onOpenPolicy }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const choice = localStorage.getItem(STORAGE_KEY);
    if (!choice) setVisible(true);
  }, []);

  if (!visible) return null;

  return (
    <div className="cookie-banner cookie-banner--floating">
      <div className="cookie-banner__text">
        <strong>We use cookies</strong> to enhance your browsing experience and analyze site traffic.
        By clicking “Accept All Cookies,” you agree to our use of cookies as described in our{' '}
        <button
          type="button"
          className="cookie-banner__link"
          onClick={() => onOpenPolicy && onOpenPolicy()}
        >
          Privacy Policy
        </button>.
      </div>

      <div className="cookie-banner__actions">
        <Button
          size="small"
          className="cookie-btn cookie-btn--reject"
          onClick={() => {
            localStorage.setItem(STORAGE_KEY, 'essential');
            setVisible(false);
          }}
        >
          Reject Non‑Essential
        </Button>

        <Button
          type="primary"
          size="small"
          className="cookie-btn cookie-btn--accept"
          onClick={() => {
            localStorage.setItem(STORAGE_KEY, 'accepted');
            setVisible(false);
          }}
        >
          Accept All Cookies
        </Button>
      </div>
    </div>
  );
}
